import React from "react";
import { Mail } from "lucide-react";
import SubPageShell from "@/apps/rider/components/SubPageShell";

export default function AccessibilityStatement() {
  return (
    <SubPageShell
      eyebrow="Legal"
      title="Accessibility statement"
      subtitle="Our commitment to building Link for every rider."
      back="/account"
      backLabel="Account"
      testId="accessibility-statement-page"
    >
      <article className="prose prose-sm sm:prose-base max-w-none text-[#0A1128]" data-testid="a11y-statement-content">
        <p className="text-[#515E7B]">Last updated: February 2026</p>

        <h2 className="font-serif text-xl mt-6">Our commitment</h2>
        <p>
          Link is committed to making scheduled transportation accessible to as
          many riders as possible. We design the rider app to align with the
          Web Content Accessibility Guidelines (WCAG) 2.1 Level AA where
          reasonable, and we improve continually as we learn from riders.
        </p>

        <h2 className="font-serif text-xl mt-6">What we ship today</h2>
        <ul>
          <li>Keyboard navigation for every interactive control on the booking surface.</li>
          <li>Visible focus indicators with high-contrast outlines.</li>
          <li>Reduced-motion support — Link honors your operating-system setting and provides a manual override at <a className="text-[#ed6500] underline-offset-4 hover:underline" href="/preferences/accessibility">Preferences → Accessibility</a>.</li>
          <li>Adjustable in-app text size (Default, Large, Larger).</li>
          <li>Screen-reader-friendly aria labels on map markers, sliders, and toggles.</li>
          <li>Light + dark themes that respect your OS preference, with manual override.</li>
        </ul>

        <h2 className="font-serif text-xl mt-6">What's next</h2>
        <ul>
          <li>Wheelchair-accessible vehicle (WAV) routing.</li>
          <li>Custom voice-over labels for stage transitions during a ride.</li>
          <li>High-contrast theme variant for use independent of OS contrast settings.</li>
        </ul>

        <h2 className="font-serif text-xl mt-6">Need help?</h2>
        <p>
          If you're having trouble using any part of Link, or have ideas to make
          it work better for you, we want to hear it directly.
        </p>
        <p className="not-prose mt-3">
          <a
            href="/support/contact"
            className="inline-flex items-center gap-2 bg-[#0A1128] text-[#F9F7F4] px-4 py-2.5 rounded-xl text-[12px] tracking-[0.2em] uppercase font-semibold"
            data-testid="a11y-statement-contact-link"
          >
            <Mail size={12} /> Contact accessibility support
          </a>
        </p>

        <h2 className="font-serif text-xl mt-6">Compliance approach</h2>
        <p>
          Link evaluates its surfaces with both automated checks (axe-core,
          Lighthouse) and manual screen-reader testing on iOS VoiceOver and
          Android TalkBack. Issues uncovered through user reports are
          prioritized into the next sprint.
        </p>
      </article>
    </SubPageShell>
  );
}
